export const themeColors = {
  colfactura: {
    tenantLanguage: "es",
    tenantDisplayName: '',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#50CBFF",
      main: "#025BA5",
      dark: "#025BA5",
      iconSend: "#16B1F3",
    },
    secondary: {
      dark: "#E45501",
      main: "#FA5A00",
      light: "#FA5A0026",
      titleText: "",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlChangePasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlSuccessAlertlogo: "",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "",
      buttonUkoColorDisabled: "",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: "",
      colorVersionCiamLabel: "",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    urlBackgroundLogin: "",
    qrLogo: "",
    logoErrorCallback: "",
  },
  colnomina: {
    tenantLanguage: "es",
    tenantDisplayName: '',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#50CBFF",
      main: "#025BA5",
      dark: "#025BA5",
      iconSend: "#16B1F3",
    },
    secondary: {
      dark: "#E45501",
      main: "#FA5A00",
      light: "#FA5A0026",
      titleText: "",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "",
      buttonUkoColorDisabled: "",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: "",
      colorVersionCiamLabel: "",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    urlBackgroundLogin: "",
    qrLogo: "",
    logoErrorCallback: "",
  },
  firmaya: {
    tenantLanguage: "es",
    tenantDisplayName: '',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#FFAB8C",
      main: "#FA5A00",
      dark: "#E55200",
      iconSend: "#E55200",
    },
    secondary: {
      dark: "#E45501",
      main: "#FA5A00",
      light: "#FA5A0026",
      titleText: "",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "",
      buttonUkoColorDisabled: "",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: "",
      colorVersionCiamLabel: "",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    urlBackgroundLogin: "",
    qrLogo: "",
    logoErrorCallback: "",
  },
  ibuhoo: {
    tenantLanguage: "es",
    tenantDisplayName: '',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FA5A00",
      light: "#FA5A0026",
      titleText: "",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
    },
    text: {
      primary: "#009BDD",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "",
      buttonUkoColorDisabled: "",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: "",
      colorVersionCiamLabel: "",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    urlBackgroundLogin: "",
    qrLogo: "",
    logoErrorCallback: "",
  },
  license: {
    tenantLanguage: "es",
    tenantDisplayName: '',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FA5A00",
      light: "#FA5A0026",
      titleText: "",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "",
      buttonUkoColorDisabled: "",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: "",
      colorVersionCiamLabel: "",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    urlBackgroundLogin: "",
    qrLogo: "",
    logoErrorCallback: "",
  },
  "GSE Suite": {
    tenantLanguage: "es",
    tenantDisplayName: '',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FA5A00",
    },
    info: {
      light: "#00000026",
      main: "#00000080",
      dark: "#00000099",
    },
    text: {
      primary: "#009BDD",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "",
      buttonUkoColorDisabled: "",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: "",
      colorVersionCiamLabel: "",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    urlBackgroundLogin: "",
    qrLogo: "",
    logoErrorCallback: "",
  },
  oidc: {
    tenantLanguage: "es",
    tenantDisplayName: '',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FA5A00",
    },
    info: {
      light: "#00000026",
      main: "#00000080",
      dark: "#00000099",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "",
      buttonUkoColorDisabled: "",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: "",
      colorVersionCiamLabel: "",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    urlBackgroundLogin: "",
    qrLogo: "",
    logoErrorCallback: "",
  },
  biometria: {
    tenantLanguage: "es",
    tenantDisplayName: '',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FA5A00",
      light: "#FA5A0026",
      titleText: "",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "",
      buttonUkoColorDisabled: "",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: "",
      colorVersionCiamLabel: "",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    urlBackgroundLogin: "",
    qrLogo: "",
    logoErrorCallback: "",
  },
  confronta: {
    tenantLanguage: "es",
    tenantDisplayName: '',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FA5A00",
      light: "#FA5A0026",
      titleText: "",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "",
      buttonUkoColorDisabled: "",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: "",
      colorVersionCiamLabel: "",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    urlBackgroundLogin: "",
    qrLogo: "",
    logoErrorCallback: "",
  },
  myselfcert: {
    tenantLanguage: "es",
    tenantDisplayName: '',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#8AB9F2",
      main: "#2499EF",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "rgba(52, 73, 94, 1)",
      light: "#F5F8FA",
      titleText: "#121F43"
    },
    info: {
      light: "#335474",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FF316F",
      main: "#FF316F1A",
      dark: "#FF316F",
    },
    urlLogo: {
      url: "LogosUko//LoginUko.png",
      urlSignIn: "LogosUko//LogoSignInUko.png",
      urlRememberPasswordlogo: "LogosUko//RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "#011E3D",
      borderInput: "#738499",
      colorLabel: "#738499",
      colorLabelFocus: "#2499EF",
      colorIcon: "#738499",
      backgroundColor: "#FFFFFF"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#DCE5F0",
      buttonUkoColorDisabled: "#A7BEDA !important",
      buttonUkoBackgroundActive: "#34495E",
      buttonUkoBackgroundSuccess: "#FFFFFF",
      buttonUkoColorDisabledResetPwd: "",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "#2499EF",
    },
    typographyMessageUko: {
      textColor: '#335474',
    },
    versionUko: {
      colorVersionLabel: "#335474",
      colorVersionCiamLabel: "",
    },
    alertUko: {
      imageUko: "LogosUko//alertUko.png",
      colorTextUko: "#335474",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    urlBackgroundLogin: "",
    qrLogo: "",
    logoErrorCallback: "",
  },
  bemyself: {
    tenantLanguage: "es",
    tenantDisplayName: 'bemyself',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#293233",
      main: "#09C3D1",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#E1FF2B !important",
      light: "#0C0C0C",
      titleText: "#F6F7F9"
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
      // light: "#EBECF3",
    },
    error: {
      light: "#FEA3B1",
      main: "#8A113A",
      dark: "#FEA3B1",
    },
    urlLogo: {
      url: "LogosUko//LoginUko.png",
      urlSignIn: "LogosUko//LogoBeMyself.svg",
      urlRememberPasswordlogo: "LogosUko//RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "#BEC8C9",
      borderInput: "#6F797A",
      colorLabel: "#BEC8C9",
      colorLabelFocus: "#09C3D1",
      colorIcon: "#B2B3BD",
      backgroundColor: "#0C0C0C"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#293233",
      buttonUkoColorDisabled: "#75788A !important",
      buttonUkoBackgroundActive: "#09C3D1",
      buttonUkoBackgroundSuccess: "#141D1E",
      buttonUkoColorDisabledResetPwd: "#3F4849 !important",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "#D5F129",
    },
    typographyMessageUko: {
      textColor: '#EBECF3',
    },
    versionUko: {
      colorVersionLabel: "#FCFDFD",
      colorVersionCiamLabel: "#FCFDFD",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "#ADB3CC",
    },
    forgotPassword: {
      colorForgotPwd: "#E1FF2B",
    },
    selectAccount: {
      colorRoot: "#09C3D1",
      colorChecked: "#09C3D1",
    },
    widthImageLogo: "220px",
    urlBackgroundLogin: "LogosUkoMyself//Backgrounds//backGroundLogin.jpg",
    qrLogo: "LogosUkoMyself//Backgrounds//QR.jpg",
    logoErrorCallback: "logoErrorCallback.png",
  },
  bemyself_472: {
    tenantLanguage: "es",
    tenantDisplayName: '472',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#293233",
      main: "#00A3DA",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#E1FF2B !important",
      light: "#0C0C0C",
      titleText: "#F6F7F9"
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
      // light: "#EBECF3",
    },
    error: {
      light: "#FEA3B1",
      main: "#8A113A",
      dark: "#FEA3B1",
    },
    urlLogo: {
      url: "LogosUko//LoginUko.png",
      urlSignIn: "LogosUkoMyself//Tenants//472.png",
      urlRememberPasswordlogo: "LogosUko//RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "#BEC8C9",
      borderInput: "#6F797A",
      colorLabel: "#BEC8C9",
      colorLabelFocus: "#00A3DA",
      colorIcon: "#B2B3BD",
      backgroundColor: "#0C0C0C"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#293233",
      buttonUkoColorDisabled: "#75788A !important",
      buttonUkoBackgroundActive: "#00A3DA",
      buttonUkoBackgroundSuccess: "#141D1E",
      buttonUkoColorDisabledResetPwd: "#3F4849 !important",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "#D5F129",
    },
    typographyMessageUko: {
      textColor: '#EBECF3',
    },
    versionUko: {
      colorVersionLabel: "#566061",
      colorVersionCiamLabel: "#FCFDFD",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "#ADB3CC",
    },
    forgotPassword: {
      colorForgotPwd: "#E1FF2B",
    },
    selectAccount: {
      colorRoot: "#BEC8C9",
      colorChecked: "#00A3DA",
    },
    widthImageLogo: "225px",
    urlBackgroundLogin: "LogosUkoMyself//Backgrounds//backGroundLogin.jpg",
    qrLogo: "LogosUkoMyself//Backgrounds//QR.jpg",
    logoErrorCallback: "logoErrorCallback.png",
  },
  bemyself_bmscol: {
    tenantLanguage: "es",
    tenantDisplayName: 'bemyself',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#293233",
      main: "#09C3D1",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#E1FF2B !important",
      light: "#0C0C0C",
      titleText: "#F6F7F9"
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
      // light: "#EBECF3",
    },
    error: {
      light: "#FEA3B1",
      main: "#8A113A",
      dark: "#FEA3B1",
    },
    urlLogo: {
      url: "LogosUko//LoginUko.png",
      urlSignIn: "LogosUko//LogoBeMyself.svg",
      urlRememberPasswordlogo: "LogosUko//RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "#BEC8C9",
      borderInput: "#6F797A",
      colorLabel: "#BEC8C9",
      colorLabelFocus: "#09C3D1",
      colorIcon: "#B2B3BD",
      backgroundColor: "#0C0C0C"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#293233",
      buttonUkoColorDisabled: "#75788A !important",
      buttonUkoBackgroundActive: "#09C3D1",
      buttonUkoBackgroundSuccess: "#141D1E",
      buttonUkoColorDisabledResetPwd: "#3F4849 !important",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "#D5F129",
    },
    typographyMessageUko: {
      textColor: '#EBECF3',
    },
    versionUko: {
      colorVersionLabel: "#566061",
      colorVersionCiamLabel: "#FCFDFD",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "#ADB3CC",
    },
    forgotPassword: {
      colorForgotPwd: "#E1FF2B",
    },
    selectAccount: {
      colorRoot: "#09C3D1",
      colorChecked: "#09C3D1",
    },
    widthImageLogo: "220px",
    urlBackgroundLogin: "LogosUkoMyself//Backgrounds//backGroundLogin.jpg",
    qrLogo: "LogosUkoMyself//Backgrounds//QR.jpg",
    logoErrorCallback: "logoErrorCallback.png",
  },
  bemyself_bmsecu: {
    tenantLanguage: "es",
    tenantDisplayName: 'bemyself',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#293233",
      main: "#09C3D1",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#E1FF2B !important",
      light: "#0C0C0C",
      titleText: "#F6F7F9"
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
      // light: "#EBECF3",
    },
    error: {
      light: "#FEA3B1",
      main: "#8A113A",
      dark: "#FEA3B1",
    },
    urlLogo: {
      url: "LogosUko//LoginUko.png",
      urlSignIn: "LogosUko//LogoBeMyself.svg",
      urlRememberPasswordlogo: "LogosUko//RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "#BEC8C9",
      borderInput: "#6F797A",
      colorLabel: "#BEC8C9",
      colorLabelFocus: "#09C3D1",
      colorIcon: "#B2B3BD",
      backgroundColor: "#0C0C0C"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#293233",
      buttonUkoColorDisabled: "#75788A !important",
      buttonUkoBackgroundActive: "#09C3D1",
      buttonUkoBackgroundSuccess: "#141D1E",
      buttonUkoColorDisabledResetPwd: "#3F4849 !important",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "#D5F129",
    },
    typographyMessageUko: {
      textColor: '#EBECF3',
    },
    versionUko: {
      colorVersionLabel: "#566061",
      colorVersionCiamLabel: "#FCFDFD",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "#ADB3CC",
    },
    forgotPassword: {
      colorForgotPwd: "#E1FF2B",
    },
    selectAccount: {
      colorRoot: "#09C3D1",
      colorChecked: "#09C3D1",
    },
    widthImageLogo: "220px",
    urlBackgroundLogin: "LogosUkoMyself//Backgrounds//backGroundLogin.jpg",
    qrLogo: "LogosUkoMyself//Backgrounds//QR.jpg",
    logoErrorCallback: "logoErrorCallback.png",
  },
  bemyself_bmsbra: {
    tenantLanguage: "pt",
    tenantDisplayName: 'bemyself',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#293233",
      main: "#09C3D1",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#E1FF2B !important",
      light: "#0C0C0C",
      titleText: "#F6F7F9"
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
      // light: "#EBECF3",
    },
    error: {
      light: "#FEA3B1",
      main: "#8A113A",
      dark: "#FEA3B1",
    },
    urlLogo: {
      url: "LogosUko//LoginUko.png",
      urlSignIn: "LogosUko//LogoBeMyself.svg",
      urlRememberPasswordlogo: "LogosUko//RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "#BEC8C9",
      borderInput: "#6F797A",
      colorLabel: "#BEC8C9",
      colorLabelFocus: "#09C3D1",
      colorIcon: "#B2B3BD",
      backgroundColor: "#0C0C0C"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#293233",
      buttonUkoColorDisabled: "#75788A !important",
      buttonUkoBackgroundActive: "#09C3D1",
      buttonUkoBackgroundSuccess: "#141D1E",
      buttonUkoColorDisabledResetPwd: "#3F4849 !important",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "#D5F129",
    },
    typographyMessageUko: {
      textColor: '#EBECF3',
    },
    versionUko: {
      colorVersionLabel: "#566061",
      colorVersionCiamLabel: "#FCFDFD",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "#ADB3CC",
    },
    forgotPassword: {
      colorForgotPwd: "#E1FF2B",
    },
    selectAccount: {
      colorRoot: "#09C3D1",
      colorChecked: "#09C3D1",
    },
    widthImageLogo: "220px",
    urlBackgroundLogin: "LogosUkoMyself//Backgrounds//backGroundLogin.jpg",
    qrLogo: "LogosUkoMyself//Backgrounds//QR.jpg",
    logoErrorCallback: "logoErrorCallback.png",
  },
  bemyself_cancilleria: {
    tenantLanguage: "es",
    tenantDisplayName: 'Cancilleria',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#293233",
      main: "#09C3D1",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#E1FF2B !important",
      light: "#0C0C0C",
      titleText: "#F6F7F9"
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
      // light: "#EBECF3",
    },
    error: {
      light: "#FEA3B1",
      main: "#8A113A",
      dark: "#FEA3B1",
    },
    urlLogo: {
      url: "LogosUko//LoginUko.png",
      urlSignIn: "LogosUko//LogoCancilleria.svg",
      urlRememberPasswordlogo: "LogosUko//RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "#BEC8C9",
      borderInput: "#6F797A",
      colorLabel: "#BEC8C9",
      colorLabelFocus: "#09C3D1",
      colorIcon: "#B2B3BD",
      backgroundColor: "#0C0C0C"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#293233",
      buttonUkoColorDisabled: "#75788A !important",
      buttonUkoBackgroundActive: "#09C3D1",
      buttonUkoBackgroundSuccess: "#141D1E",
      buttonUkoColorDisabledResetPwd: "#3F4849 !important",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "#D5F129",
    },
    typographyMessageUko: {
      textColor: '#EBECF3',
    },
    versionUko: {
      colorVersionLabel: "#566061",
      colorVersionCiamLabel: "#FCFDFD",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "#ADB3CC",
    },
    forgotPassword: {
      colorForgotPwd: "#E1FF2B",
    },
    selectAccount: {
      colorRoot: "#09C3D1",
      colorChecked: "#09C3D1",
    },
    widthImageLogo: "220px",
    urlBackgroundLogin: "LogosUkoMyself//Backgrounds//backGroundLogin.jpg",
    qrLogo: "LogosUkoMyself//Backgrounds//QR.jpg",
    logoErrorCallback: "logoErrorCallback.png",
  },
  bemyself_demobms: {
    tenantLanguage: "es",
    tenantDisplayName: 'bemyself demo',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#293233",
      main: "#09C3D1",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#E1FF2B !important",
      light: "#0C0C0C",
      titleText: "#F6F7F9"
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
      // light: "#EBECF3",
    },
    error: {
      light: "#FEA3B1",
      main: "#8A113A",
      dark: "#FEA3B1",
    },
    urlLogo: {
      url: "LogosUko//LoginUko.png",
      urlSignIn: "LogosUko//Logo_bemyself_demo_Light.svg",
      urlRememberPasswordlogo: "LogosUko//RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "#BEC8C9",
      borderInput: "#6F797A",
      colorLabel: "#BEC8C9",
      colorLabelFocus: "#09C3D1",
      colorIcon: "#B2B3BD",
      backgroundColor: "#0C0C0C"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#293233",
      buttonUkoColorDisabled: "#75788A !important",
      buttonUkoBackgroundActive: "#09C3D1",
      buttonUkoBackgroundSuccess: "#141D1E",
      buttonUkoColorDisabledResetPwd: "#3F4849 !important",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "#D5F129",
    },
    typographyMessageUko: {
      textColor: '#EBECF3',
    },
    versionUko: {
      colorVersionLabel: "#566061",
      colorVersionCiamLabel: "#FCFDFD",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "#ADB3CC",
    },
    forgotPassword: {
      colorForgotPwd: "#E1FF2B",
    },
    selectAccount: {
      colorRoot: "#09C3D1",
      colorChecked: "#09C3D1",
    },
    widthImageLogo: "220px",
    urlBackgroundLogin: "LogosUkoMyself//Backgrounds//backGroundLogin.jpg",
    qrLogo: "LogosUkoMyself//Backgrounds//QR.jpg",
    logoErrorCallback: "logoErrorCallback.png",
  },
  bemyself_letmiecu: {
    tenantLanguage: "es",
    tenantDisplayName: 'Letmi Ecuador',
    fontFamilyApp: 'Inter',
    primary: {
      light: "#293233",
      main: "#39E0C3",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#E1FF2B !important",
      light: "#0C0C0C",
      titleText: "#F6F7F9"
    },
    info: {
      light: "#DAE4E5",
      main: "#00000080",
      dark: "#C1C1C1",
      // light: "#EBECF3",
    },
    error: {
      light: "#FEA3B1",
      main: "#8A113A",
      dark: "#FEA3B1",
    },
    urlLogo: {
      url: "LogosUko//LoginUko.png",
      urlSignIn: "LogosUko//letmicertLogo.svg",
      urlRememberPasswordlogo: "LogosUko//RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "#BEC8C9",
      borderInput: "#6F797A",
      colorLabel: "#BEC8C9",
      colorLabelFocus: "#09C3D1",
      colorIcon: "#B2B3BD",
      backgroundColor: "#0C0C0C"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#293233",
      buttonUkoColorDisabled: "#75788A !important",
      buttonUkoBackgroundActive: "#0059AD",
      buttonUkoBackgroundSuccess: "#FCFDFD",
      buttonUkoColorDisabledResetPwd: "#3F4849 !important",
      buttonJustifyContent: 'space-between',
      buttonEndIcon: true,
      buttonFontSize: '13px',
    },
    linkUko: {
      colorLink: "#07D8B4",
    },
    typographyMessageUko: {
      textColor: '#EBECF3',
    },
    versionUko: {
      colorVersionLabel: "#566061",
      colorVersionCiamLabel: "#FCFDFD",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "#ADB3CC",
    },
    forgotPassword: {
      colorForgotPwd: "#E1FF2B",
    },
    selectAccount: {
      colorRoot: "#BEC8C9",
      colorChecked: "#07D8B4",
    },
    widthImageLogo: "220px",
    urlBackgroundLogin: "LogosUkoMyself//Backgrounds//backGroundLogin.jpg",
    qrLogo: "LogosUkoMyself//Backgrounds//QR.jpg",
    logoErrorCallback: "logoErrorCallback.png",
  },
  bemyself_herta: {
    tenantLanguage: "es",
    tenantDisplayName: 'bemyself demo',
    fontFamilyApp: 'Montserrat',
    primary: {
      light: "#293233",
      main: "#09C3D1",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#E1FF2B !important",
      light: "#0C0C0C",
      titleText: "#F6F7F9"
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
      // light: "#EBECF3",
    },
    error: {
      light: "#FEA3B1",
      main: "#8A113A",
      dark: "#FEA3B1",
    },
    urlLogo: {
      url: "LogosUko//LoginUko.png",
      urlSignIn: "LogosUko//Logo_bemyself_demo_Light.svg",
      urlRememberPasswordlogo: "LogosUko//RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "#BEC8C9",
      borderInput: "#6F797A",
      colorLabel: "#BEC8C9",
      colorLabelFocus: "#09C3D1",
      colorIcon: "#B2B3BD",
      backgroundColor: "#0C0C0C"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#293233",
      buttonUkoColorDisabled: "#75788A !important",
      buttonUkoBackgroundActive: "#09C3D1",
      buttonUkoBackgroundSuccess: "#141D1E",
      buttonUkoColorDisabledResetPwd: "#3F4849 !important",
      buttonJustifyContent: '',
      buttonEndIcon: '',
      buttonFontSize: '16px',
    },
    linkUko: {
      colorLink: "#D5F129",
    },
    typographyMessageUko: {
      textColor: '#EBECF3',
    },
    versionUko: {
      colorVersionLabel: "#566061",
      colorVersionCiamLabel: "#FCFDFD",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "#ADB3CC",
    },
    forgotPassword: {
      colorForgotPwd: "#E1FF2B",
    },
    selectAccount: {
      colorRoot: "#09C3D1",
      colorChecked: "#09C3D1",
    },
    widthImageLogo: "220px",
    urlBackgroundLogin: "LogosUkoMyself//Backgrounds//backGroundLogin.jpg",
    qrLogo: "LogosUkoMyself//Backgrounds//QR.jpg",
    logoErrorCallback: "logoErrorCallback.png",
  },
  bemyself_telecpa: {
    tenantLanguage: "es",
    tenantDisplayName: 'Tribual Electoral',
    fontFamilyApp: 'Inter',
    primary: {
      light: "#293233",
      main: "#6F797A",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#E1FF2B !important",
      light: "#0C0C0C",
      titleText: "#F6F7F9"
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
      // light: "#EBECF3",
    },
    error: {
      light: "#FEA3B1",
      main: "#8A113A",
      dark: "#FEA3B1",
    },
    urlLogo: {
      url: "LogosUko//LoginUko.png",
      urlSignIn: "LogosUko//LogoTribunal.svg",
      urlRememberPasswordlogo: "LogosUko//RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "#BEC8C9",
      borderInput: "#6F797A",
      colorLabel: "#BEC8C9",
      colorLabelFocus: "#6F797A",
      colorIcon: "#B2B3BD",
      backgroundColor: "#141D1E"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#293233",
      buttonUkoColorDisabled: "#293233 !important",
      buttonUkoBackgroundActive: "#073087",
      buttonUkoBackgroundSuccess: "#FCFDFD",
      buttonUkoColorDisabledResetPwd: "#3F4849 !important",
      buttonJustifyContent: 'space-between',
      buttonEndIcon: true,
      buttonFontSize: '13px',
    },
    linkUko: {
      colorLink: "#E1FF2B",
    },
    typographyMessageUko: {
      textColor: '#EBECF3',
    },
    versionUko: {
      colorVersionLabel: "#566061",
      colorVersionCiamLabel: "#FCFDFD",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "#ADB3CC",
    },
    forgotPassword: {
      colorForgotPwd: "#E1FF2B",
    },
    selectAccount: {
      colorRoot: "#BEC8C9",
      colorChecked: "#073087",
    },
    widthImageLogo: "220px",
    urlBackgroundLogin: "LogosUkoMyself//Backgrounds//backGroundLogin.jpg",
    qrLogo: "LogosUkoMyself//Backgrounds//QR.jpg",
    logoErrorCallback: "logoErrorCallback.png",
  },
  bemyself_ponalcol: {
    tenantLanguage: "es",
    tenantDisplayName: 'Policia Nacional',
    fontFamilyApp: 'Inter',
    primary: {
      light: "#293233",
      main: "#6F797A",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#E1FF2B !important",
      light: "#0C0C0C",
      titleText: "#F6F7F9"
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
      // light: "#EBECF3",
    },
    error: {
      light: "#FEA3B1",
      main: "#8A113A",
      dark: "#FEA3B1",
    },
    urlLogo: {
      url: "LogosUko//LoginUko.png",
      urlSignIn: "LogosUko//LogoPolicia.svg",
      urlRememberPasswordlogo: "LogosUko//RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
    },
    InputUko: {
      colorInputLetter: "#BEC8C9",
      borderInput: "#6F797A",
      colorLabel: "#BEC8C9",
      colorLabelFocus: "#6F797A",
      colorIcon: "#B2B3BD",
      backgroundColor: "#141D1E"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#293233",
      buttonUkoColorDisabled: "#293233 !important",
      buttonUkoBackgroundActive: "#CDFF00",
      buttonUkoBackgroundSuccess: "#141D1E",
      buttonUkoColorDisabledResetPwd: "#3F4849 !important",
      buttonJustifyContent: 'space-between',
      buttonEndIcon: true,
      buttonFontSize: '13px',
    },
    linkUko: {
      colorLink: "#E1FF2B",
    },
    typographyMessageUko: {
      textColor: '#EBECF3',
    },
    versionUko: {
      colorVersionLabel: "#566061",
      colorVersionCiamLabel: "#FCFDFD",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "#ADB3CC",
    },
    forgotPassword: {
      colorForgotPwd: "#E1FF2B",
    },
    selectAccount: {
      colorRoot: "#BEC8C9",
      colorChecked: "#CDFF00",
    },
    widthImageLogo: "243px",
    urlBackgroundLogin: "LogosUkoMyself//Backgrounds//backGroundLogin.jpg",
    qrLogo: "LogosUkoMyself//Backgrounds//QR.jpg",
    logoErrorCallback: "logoErrorCallback.png",
  }
};

/*
  primary -> light: #009BDD / main: #1D71B8  / dark: #003582
  secondary -> light: #FA5A00  / main: #FA5A00  / dark:  #E45501
  error -> light:  / main:  / dark:
  warning -> light:  / main:  / dark:
  info -> light:  #00000026 / main: #00000080 / dark:  #00000099
  success -> light:  / main:  / dark:
 */
